// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PublicQrCodeResponse

import { hydrateQrCodeScan, type QrCodeScan, type QrCodeScanApiResponse } from './qrCodeScan.gen';
import { hydrateBusiness, type Business, type BusinessApiResponse } from './business.gen';
import { hydrateBooking, type Booking, type BookingApiResponse } from './booking.gen';
import { hydrateOffer, type Offer, type OfferApiResponse } from './offer.gen';
import { hydrateProduct, type Product, type ProductApiResponse } from './product.gen';
import { hydratePromoCode, type PromoCode, type PromoCodeApiResponse } from './promoCode.gen';

export type PublicQrCodeApiResponse = {
	scans: QrCodeScanApiResponse[];
	business: BusinessApiResponse;
	bookings: BookingApiResponse[];
	offers: OfferApiResponse[];
	products: ProductApiResponse[];
	promoCodes: PromoCodeApiResponse[];
};

export type PublicQrCode = {
	scans: QrCodeScan[];
	business: Business;
	bookings: Booking[];
	offers: Offer[];
	products: Product[];
	promoCodes: PromoCode[];
};

export function hydratePublicQrCode(data: PublicQrCodeApiResponse): PublicQrCode {
	return {
		...data,
		scans: data.scans.map(hydrateQrCodeScan),
		business: hydrateBusiness(data.business),
		bookings: data.bookings.map(hydrateBooking),
		offers: data.offers.map(hydrateOffer),
		products: data.products.map(hydrateProduct),
		promoCodes: data.promoCodes.map(hydratePromoCode),
	};
}